export const month = [
    {
        month:1,
        active:false
    },
    {
        month:2,
        active:false
    },
    {
        month:3,
        active:false
    },
    {
        month:4,
        active:false
    },
    {
        month:5,
        active:false
    },
    {
        month:6,
        active:false
    },
    {
        month:7,
        active:false
    },
    {
        month:8,
        active:false
    },
    {
        month:9,
        active:false
    },
    {
        month:10,
        active:false
    },
    {
        month:11,
        active:false
    },
    {
        month:12,
        active:false
    },
];